<template>
  <v-layout column>
    <h3>{{ editMode ? "Update Property Additional Charge" : "Create new Property Additional Charge" }}</h3>
    <v-flex align-center justify-center>
      <form>
        <v-text-field
          v-model="form.name"
          :error-messages="nameErrors"
          label="Name"
          required
          maxlength="60"
          @input="$v.form.name.$touch()"
          @blur="$v.form.name.$touch()"
        ></v-text-field>
        <v-switch v-model="form.chargeCommission" label="       Charge Commission" required></v-switch>
        <v-switch v-model="form.enabled" label="       Enabled" required></v-switch>
        <v-text-field
          class="mt-2"
          v-model="form.amount"
          :rules="[monetaryValueValidator]"
          label="Amount"
          autofocus
          prefix="£"
        ></v-text-field>
        <v-select v-model="form.property" :items="properties" item-text="name" item-value="value" ></v-select>
       <v-btn
          class="text-none"
          large
          color="green lighten-2"
          dark
          @click="submit"
        >{{ editMode ? "Update" : "Create" }}</v-btn>
      </form>
    </v-flex>
  </v-layout>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";

// import { setTimeout } from "timers";

export default {
  name: "property_additional_charge_details",
  components: {
  },
  props: {
    loading: { type: Boolean, default: false },
    editMode: { type: Boolean, default: false },
    propertyAdditionalChargeDetails: { type: Object, default: null }
  },
  data: function() {
    return {
      properties: [
        { name: "Pets", value: "property_pets"},
        { name: "Meet and Greet", value: "property_meet_and_greet"},
        { name: "Requires PPE", value: "property_ppe"},
        { name: "Priority Customer", value: "property_priority_customer"},
        { name: "Wheelchair Required", value: "property_disabled_access"},
      ],
      form: {
        name: "",
        enabled: true,
        chargeCommission: true,
        amount: 0,
        property: null,
      },
      monetaryValueValidator: (v) =>
        /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
    };
  },
  validations: {
    form: {
      name: { required },
      nameForCustomer: { required }
    }
  },
  beforeMount: function() {
    if (this.propertyAdditionalChargeDetails != null) {
      this.form.name = this.propertyAdditionalChargeDetails.name;
      this.form.chargeCommission = this.propertyAdditionalChargeDetails.chargeCommission;
      this.form.enabled = this.propertyAdditionalChargeDetails.enabled;
      this.form.property = this.propertyAdditionalChargeDetails.property;
      this.form.amount = (this.propertyAdditionalChargeDetails.amount / 100).toFixed(2);
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push("Name is required.");
      return errors;
    },
    nameForCustomerErrors() {
      const errors = [];
      if (!this.$v.form.nameForCustomer.$dirty) return errors;
      !this.$v.form.nameForCustomer.required &&
        errors.push("Name for customer is required.");
      return errors;
    }
  },
  methods: {
    submit: function() {
     this.$emit("submitted", this.form);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.v-label {
  padding-left: 8px;
}
</style>
